import React from "react";
import { sumBy } from "lodash";
import { CustomModal } from "./styles";
import {
  Container,
  Header,
  Title,
  Subtitle,
  Section,
  SectionTitle,
  Table,
} from "./ExhibitLayout";

const avg = (items, key) => (sumBy(items, key) / items.length).toFixed(2);

const ModalExhibit6 = ({ comparableCompanies, goBack }) => (
  <CustomModal goBack={goBack}>
    <Container>
      <Header>
        <Title>Exhibit 6: Valuation Methods & Comps</Title>
        <Subtitle>How the company is valued in each year of the simulation, and the comparable public companies used as benchmarks.</Subtitle>
      </Header>

      <Section>
        <SectionTitle>Valuation Method by Year</SectionTitle>
        <Table>
          <thead>
            <tr>
              <th>Year</th>
              <th>Valuation Method</th>
              <th>Rationale</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><b>1 and 2</b></td>
              <td>Price to Sales (P/S)</td>
              <td>Early on, your business does not yet have steady profits, so it is valued off revenues. We multiply your revenues by the average P/S ratio of the comparable public companies below, which reflects what the market currently pays for each dollar of sales at similar businesses.</td>
            </tr>
            <tr>
              <td><b>3 and 4</b></td>
              <td>Price to Earnings (P/E)</td>
              <td>By now your business is generating consistent profits. We multiply your net earnings by the average P/E ratio of the comparable public companies below, which reflects what the market currently pays for each dollar of earnings at similar businesses.</td>
            </tr>
            <tr>
              <td><b>5 to 8</b></td>
              <td>Discounted Cash Flows (DCF)</td>
              <td>With a longer track record, your future cash flows can be projected with reasonable confidence. We discount those projected free cash flows back to today's dollars using rates that reflect the risk and returns of the comparable public companies below.</td>
            </tr>
          </tbody>
        </Table>
      </Section>

      <Section>
        <SectionTitle>Comparable Public Companies</SectionTitle>
        <Table>
          <thead>
            <tr>
              <th>Comparable</th>
              <th>Price to Sales (P/S)</th>
              <th>Price to Earnings (P/E)</th>
            </tr>
          </thead>
          <tbody>
            {comparableCompanies.map(company => (
              <tr key={company.id}>
                <td><b>{company.name}</b></td>
                <td className="numeric">{company.price_to_sales.toFixed(2)}</td>
                <td className="numeric">{company.price_to_earnings.toFixed(2)}</td>
              </tr>
            ))}
            <tr className="highlight">
              <td>Average Comps</td>
              <td className="numeric">{avg(comparableCompanies, "price_to_sales")}</td>
              <td className="numeric">{avg(comparableCompanies, "price_to_earnings")}</td>
            </tr>
          </tbody>
        </Table>
      </Section>
    </Container>
  </CustomModal>
);

export default ModalExhibit6;



// WEBPACK FOOTER //
// ./src/components/bcase/ModalExhibit6.js